import React from "react";
import { BellRing } from "lucide-react";
import TabPageLayout from "modules/swiftboard/components/TabPageLayout";
import useUrlTab from "modules/swiftboard/components/useUrlTab";
import Rule from "./rule/Rule";

// Where reminders are put together (tbl_rem_rule + tbl_rem_rule_step): a trigger, a schedule, an audience and an
// escalation ladder. `slug` is the ?tab= value: keep it stable even if the label changes.
const REMINDER_DESIGNER_TABS = [{ id: 1, slug: "rule", label: "Rule", Icon: BellRing, Page: Rule }];

const ReminderDesigner = () => {
  const [activeTab, setActiveTab] = useUrlTab(REMINDER_DESIGNER_TABS.map((tab) => tab.slug));
  const tabs = REMINDER_DESIGNER_TABS.map(({ id, label, Icon }) => ({ id, label, icon: <Icon size={18} /> }));
  const { slug, Page } = REMINDER_DESIGNER_TABS[activeTab];

  return (
    <TabPageLayout tabs={tabs} activeTab={activeTab} onTabChange={(index) => setActiveTab(index)}>
      <Page key={slug} />
    </TabPageLayout>
  );
};

export default ReminderDesigner;
